import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import ToolTip from '../../../ui/ToolTip'

const ModalPeriodicidadPago = ({ tienda, setTienda, periodicidades, tiendaBD }) => {
  const [idPeriodicidad, setIdPeriodicidad] = useState(0)
  const [nombrePeriodicidad, setNombrePeriodicidad] = useState('')
  const [show, setShow] = useState(false)
  const deshabilitado = !!tiendaBD.idTiendaOficialPeriodicidad

  useEffect(() => {
    setIdPeriodicidad(tiendaBD.idTiendaOficialPeriodicidad)
    setNombrePeriodicidad(tiendaBD.nombrePeriodicidad)
  }, [tiendaBD.idTiendaOficialPeriodicidad])

  const manejarModal = () => {
    setIdPeriodicidad(tienda.idTiendaOficialPeriodicidad || 0)
    setShow(!show)
  }

  const handleGuardar = () => {
    setTienda((prev) => ({
      ...prev,
      idTiendaOficialPeriodicidad: idPeriodicidad,
      nombrePeriodicidad,
      errores: {}
    }))
    manejarModal()
  }

  const onChangePeriodicidad = (id, nombre) => {
    if (idPeriodicidad !== id) {
      setIdPeriodicidad(id)
      setNombrePeriodicidad(nombre)
    }
  }

  return (
    <div>
      <Button
        data-target="#periodicidadCobro"
        data-toggle="modal"
        variant="datos-perfil"
        onClick={manejarModal}
      >
        <span className="float-left">Periodicidad de Cobro</span>
        <span className="float-right">{tienda.nombrePeriodicidad}</span>
      </Button>

      {show && (
        <div
          className="modal fade show d-block"
          role="dialog"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={manejarModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: '30%' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="modalTitulo">
                  Selecciona cada cuanto tiempo quieres pagar
                </h4>
                <button
                  type="button"
                  className="close"
                  aria-label="Cerrar"
                  onClick={manejarModal}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.5rem',
                    lineHeight: 1,
                    cursor: 'pointer'
                  }}
                >
                  <span aria-hidden="true">x</span>
                </button>
              </div>

              <div className="modal-body">
                <h3>Periodicidad</h3>
                <div className="ml-2">
                  <ul>
                    {periodicidades.map(
                      ({ idTiendaOficialPeriodicidad: id, nombrePeriodicidad }) => (
                        <ToolTip
                          key={id}
                          contenido="No es posible modificarse la periodicidad del pago ya que posees un Plan Tienda Oficial en vigencia"
                          flecha={true}
                          duracion={0}
                          esconder={!deshabilitado}
                        >
                          <li
                            id="contenedorLiPlanes"
                            className={
                              id === idPeriodicidad
                                ? 'datos-perfil border-green-2px fa fa-check-circle aria-hidden=true'
                                : 'datos-perfil'
                            }
                            style={{ cursor: deshabilitado ? 'not-allowed' : 'pointer' }}
                            onClick={() =>
                              !deshabilitado &&
                              onChangePeriodicidad(id, nombrePeriodicidad)
                            }
                          >
                            <p id="nombreModalTipoPeriodicidad">
                              &nbsp;{nombrePeriodicidad}
                            </p>
                          </li>
                        </ToolTip>
                      )
                    )}
                  </ul>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={manejarModal}
                >
                  Cerrar
                </button>
                <button type="button" className="btn btn-primary" onClick={handleGuardar}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

ModalPeriodicidadPago.propTypes = {
  tienda: PropTypes.shape({
    idTiendaOficialPeriodicidad: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    nombrePeriodicidad: PropTypes.string
  }).isRequired,
  setTienda: PropTypes.func.isRequired,
  periodicidades: PropTypes.arrayOf(
    PropTypes.shape({
      idTiendaOficialPeriodicidad: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
      nombrePeriodicidad: PropTypes.string.isRequired
    })
  ).isRequired,
  tiendaBD: PropTypes.shape({
    idTiendaOficialPeriodicidad: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    nombrePeriodicidad: PropTypes.string
  }).isRequired
}

export default ModalPeriodicidadPago
